import { createVNode, mergeProps } from "vue";
export default {
  name: 'CodepenIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-codepen"
    }, { ...attrs
    }), [createVNode("polygon", {
      "points": "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"
    }), createVNode("line", {
      "x1": "12",
      "y1": "22",
      "x2": "12",
      "y2": "15.5"
    }), createVNode("polyline", {
      "points": "22 8.5 12 15.5 2 8.5"
    }), createVNode("polyline", {
      "points": "2 15.5 12 8.5 22 15.5"
    }), createVNode("line", {
      "x1": "12",
      "y1": "2",
      "x2": "12",
      "y2": "8.5"
    })]);
  }

};